import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { orders, products, brands } from "data/actions";
import RaisedButton from "material-ui/RaisedButton";
import { Page, PageSection, PageBlock, RightDrawer, PageMenu } from "components/Page";
import DropdownField from "components/Form/DropdownField";
import Price from "components/Formaters/Price";

import Subheader from "material-ui/Subheader";
import Row from "components/Form/Row";
import MenuLink from "components/Navigation/MenuLink";

import Field from "components/Form/Field";
import * as os from "osutil";
import { OrderStatus } from "data/orders/types";
import OrderProductEditor from "components/Form/OrderProductEditor";

class Order extends Component {

  static contextTypes = {
    router: PropTypes.object
  };

  state = { tab: "overview", open: false, bookingdata:{} };

  tabs = [
    { label: "Översikt", key: "overview" },
    { label: "Bokningar", key: "orders" },
  ];


  handleNav = e => {
    this.setState({ ...this.state, tab: e });
  };

  handleBruttocontactChange = (key, field) => {
    console.log(key, field, field.state.value)
    var bookingdata = { ...this.state.bookingdata, [key]: { bruttocontacts: field.state.value} }

    this.setState({ ...this.state, bookingdata }, () => {console.log(this.state)});
  };

  handleCancel(id) {
    this.context.router.history.push("/admin/orders");
  }

  componentWillMount() {
    this.props.actions.fetchBrands();
    this.props.actions.fetchProducts();
    this.props.actions.fetchOrders();
  }

  handleFormSubmit(event) {
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    let merged = Object.assign(this.props.order.details, ...data);
    this.props.actions.updateOrder(
      this.props.user.accountid,
      this.props.params.id,
      merged
    );
  }

  handleBookingFormSubmit = (event) => {
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
console.log(this.props.order.bookings)
    let merged = _.merge(this.props.order.bookings, this.state.bookingdata) 
    console.log(this.props.order, merged, this.props.order.bookings, this.state.bookingdata);
    this.props.actions.updateBooking(
      this.props.order.details.accountid,
      this.props.params.id,
      merged
    );
  }


  handleReportsSubmit = () => {
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    data.status = "booked";
    let merged = Object.assign(this.props.order.details, ...data);
    merged.status = "booked";
    this.props.actions.updateOrder(
      this.props.user.accountid,
      this.props.params.id,
      merged
    );
  };


  handleSendBooking = () => {
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    data.status = "booked";
    let merged = Object.assign(this.props.order.details, ...data);
    merged.status = "booked";
    this.props.actions.updateOrder(
      this.props.user.accountid,
      this.props.params.id,
      merged
    );
  };

  handleStatusChange = (key, event, index, value) => {};

  renderEditions = (list, product) => {
    return _.map(list, (e, key) => {
      var pe = product.editions[key];
      if (pe) {
        return (
          <span key={key} className="campaign_item_editions_item">
            {pe.number}
          </span>
        );
      }
    });
  };

  renderBookings = () => {
    return _.map(this.props.order.bookings, (b, key) => {
      var p = this.props.products[b.productid];
      if (p) {
        var brand = this.props.brands[p.brandid];
        if (brand) {
          var pos = p.positions[b.positionid];
          return (
            <li key={key} className="campaign_item">
              <span className="campaign_item_header">
                <span className="campaign_item_product">{p.name}</span>
                <span className="campaign_item_brand">{brand.name}</span>
                <span className="campaign_item_brand_logo">
                  <img alt={brand.name} src={brand.logoUrl} />
                </span>
              </span>
              <span className="campaign_item_price">
                Pris: <Price value={p.netprice} />
              </span>
              <span className="campaign_item_position">
                Plats: {pos ? pos.value : "Ej spec"}
              </span>
              <span className="campaign_item_editions">
                Utgåvor: {this.renderEditions(b.editions, p)}
              </span>
              <Field
                floatingLabelText="bruttokontakter"
                ref="bruttokontakter"
                value={this.state.bookingdata[key] ? this.state.bookingdata[key].bruttocontacts : b.bruttocontacts}
                handleChange={this.handleBruttocontactChange.bind(this,key)}
              />
            </li>
          );
        }
      }
    });
  };


  render() {
    if (!this.props.order || !this.props.order.details) {
      return null;
    }
    var total = os.getTotalPrice(this.props.order, this.props.products);
    return [
      <RightDrawer key="right">
        <PageBlock label={`Kampanj: ${this.props.order.details.name}`}>
        <PageMenu onNav={this.handleNav} tabs={this.tabs} title="Konto" />
      </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <Subheader>
          <MenuLink label="Bokningar" to="/admin/orders" />
          <span className="pathsep" />
          <MenuLink
            label={this.props.order.details.name}
            to={this.props.params.id}
          />
        </Subheader>
        <div
          onSubmit={this.handleFormSubmit.bind(this)}
          className="form-inline"
        >
        {this.state.tab === "overview" && (
          
          <PageSection label="Kampanj">
            <Row>
              <Field
                ref="name"
                value={this.props.order.details.name}
                floatingLabelText="Namn"
              />
            </Row>
            <Row>
              <Field
                multiLine={true}
                ref="description"
                value={this.props.order.details.description}
                floatingLabelText="Anteckningar"
              />
            </Row>
            <Row>
              <DropdownField
                ref="status"
                value={this.props.order.details.status}
                label="Status"
                options={OrderStatus}
              />
            </Row>
            <Row styleName="padded">
              <RaisedButton
                onTouchTap={this.handleFormSubmit.bind(this)}
                primary={true}
                label="Spara"
              />
              <RaisedButton
                onTouchTap={this.handleCancel.bind(this)}
                label="Stäng"
              />
            </Row>
          </PageSection>
          )}
        
        {this.state.tab === "orders" && (
          <PageSection label="Bokningar">
            <Row>
              <ul className="campaign_booking">{this.renderBookings()}</ul>
            </Row>
            <Row styleName="padded">
              <RaisedButton
                onTouchTap={this.handleBookingFormSubmit.bind(this)}
                primary={true}
                label="Spara"
              />
              <RaisedButton
                onTouchTap={this.handleCancel.bind(this)}
                label="Stäng"
              />
            </Row>
          </PageSection>
        )}
        </div>
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  var order = {};
  _.forEach(state.orders.list.data, (a, ka) => {
    _.forEach(a, (c, kc) => {
      if (kc === ownProps.params.id) {
        order = c;
      }
    });
  });
  return {
    order: order,
    user: state.auth.user,
    products: state.products.list.data,
    brands: state.brands.list.data,
    pending: state.orders.list.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators({ ...products, ...orders, ...brands }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch)(Order);



// WEBPACK FOOTER //
// ./src/pages/admin/orders/Order.jsx